// Example starter JavaScript for disabling form submissions if there are invalid fields
const DEFAULT_STORE = 1;
  
(function () {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll('.needs-validation')

  // Fetch a specific field
  // var mondialrelaySelected = $('#mondialrelay_selected');

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {

        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }

        form.classList.add('was-validated')
      }, false)
    })
})()


function getStore() {
  const queryString = window.location.search;
  if (queryString) {
    const urlParams = new URLSearchParams(queryString);
    const store = urlParams.get('store');
    if (store)
      return store;
  }
  return DEFAULT_STORE;
}

// Fonction pour lire un cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
// Fonction pour récupérer l'historique des paiements
function getPaymentsHistory() {
  const paymentsHistory = getCookie('orderHistory'); // Lire le cookie
  if (paymentsHistory) {
    return JSON.parse(paymentsHistory); // Convertir le JSON en objet JavaScript
  }
  return []; // Retourne un tableau vide si aucun historique n'est trouvé
}

function hasPaymentToday() {
  const payments = getPaymentsHistory();
  const nbHourRange = 9

  if (payments.length === 0) {
    return false;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const store = urlParams.get('store') || '1';

  // Récupérer l'heure actuelle
  const now = new Date();

  // Déterminer le début et la fin de la période de 9h à 9h
  let startOfPeriod, endOfPeriod;

  if (now.getHours() < nbHourRange) {
    // Si on est avant 9h du matin, la période actuelle a commencé hier à 9h
    startOfPeriod = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, nbHourRange, 0, 0).getTime();
    endOfPeriod = new Date(now.getFullYear(), now.getMonth(), now.getDate(), nbHourRange, 0, 0).getTime();
  } else {
    // Sinon, la période actuelle a commencé aujourd’hui à 9h et finit demain à 9h
    startOfPeriod = new Date(now.getFullYear(), now.getMonth(), now.getDate(), nbHourRange, 0, 0).getTime();
    endOfPeriod = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, nbHourRange, 0, 0).getTime();
  }


  // Vérifier si un paiement a eu lieu pendant cette plage horaire (9h à 9h)
  for (let payment of payments) {
    const paymentStore = payment.store || '1';

    if (payment.status === "success" && paymentStore === store) {
      const paymentTimestamp = payment.timestamp * 1000;
      if (paymentTimestamp >= startOfPeriod && paymentTimestamp < endOfPeriod) {
        return true;
      }
    }
  }

  return false;
}



$("#form").on("submit", (e) => {
   e.preventDefault();

    //$("#form-errors").hide()
    $('#submitButton').hide()
    $('#submitButtonProcess').show()
    
    $('#error-form').hide()

  const shipAlreadyPaid = hasPaymentToday()
  const store = getStore()

  const data = {
    amount: shipAlreadyPaid ? $("#amount").val() : `${parseInt($("#amount").val()) + 5}`,
    reference: $("#reference").val(),
    tiktok: $("#tiktok").val(),
    email: $("#email").val(),
    lastname: $("#lastname").val(),
    firstname: $("#firstname").val(),
    address: $("#address").val(),
    zipcode: $("#zipcode").val(),
    country:  $("#country").val(),
    city: $("#city").val(),
    phone: $("#phone").val()
  };  

  const areAllFieldsFilled = Object.values(data).every(field => field && field.trim() !== "");


  if (!shipAlreadyPaid && $("#chronopost_info-container-id").text() == "") {
      $('#submitButton').show()
      $('#submitButtonProcess').hide()
    
      //$("#form-errors").show()
      return
  }

  const chronopostRelayData = {
    chronopost_selectedRelay: $("#chronopost_info-container-id").text(),
    chronopost_name: $('#chronopost_info-container-name').text(),
    chronopost_address1: $('#chronopost_info-container-address1').text(),
    chronopost_address2: $('#chronopost_info-container-address2').text(),
    chronopost_zipcode: $('#chronopost_info-container-cp').text(),
    chronopost_city: $('#chronopost_info-container-ville').text(),
    chronopost_country: $('#chronopost_info-container-pays').text(),
    shipAlreadyPaid: shipAlreadyPaid,
  }


  if (areAllFieldsFilled) {
    axios.post('https://lylaa.fr:5000/create-checkout-session', { ...data, ...chronopostRelayData, ...{store: store} })
    .then(response => {
      if (response.data && response.data.url) {
        // Redirige vers le lien récupéré
        window.location.href = response.data.url;
      } else {    
        $('#error-form').show()
      }
    })
    .catch(error => {
      $('#error-form').show()
      console.error('Erreur lors de la récupération du lien depuis l\'API :', error);
    }).finally(() => {
        
      $('#submitButton').show()
      $('#submitButtonProcess').hide()
    });
  } else { 
      //$("#form-errors").show()
      $('#submitButton').show()
      $('#submitButtonProcess').hide()
  }
});

const freeShipping = hasPaymentToday()
const shippingPrice = freeShipping ? 0 : 5
const amount = 0


if (freeShipping) {
  $("#container-chronopost-select-ship").hide()  
  $('#no-chronopost').show()
}

const fromHelper = {
  init: function () {
    $('#form .input-group.amount input').on('change', this.updateAmount);
    
   $('#shop-amount').text(amount.toFixed(2));
   $('#shop-shipping').text(shippingPrice.toFixed(2));
   $('#shop-total-amount').text(shippingPrice.toFixed(2));
   $('#carrier-price').text(shippingPrice.toFixed(2));
    
    
  },
  updateAmount: function (e) {
    const value = parseFloat(e.target.value);
     $('#shop-amount').text(value.toFixed(2));
     $('#shop-total-amount').text((value + shippingPrice).toFixed(2));
  }
}


fromHelper.init();